import React from "react"
import { Link } from "react-router-dom"
import "./SiteFooter.css"

// Rendered once by AppLayout, at the end of every page's content —
// marketing and dashboard alike.
const SiteFooter = () => (
  <footer className="epw-site-footer">
    <div className="epw-site-footer-inner">
      <span>Copyright © EnergyPulseWorld.com 2026. All rights reserved.</span>
      <Link to="/disclaimer">Disclaimer</Link>
    </div>
  </footer>
)

export default SiteFooter
